import { ArrowDownBoldBoxOutlineIcon } from './ArrowDownBoldBoxOutlineIcon';

/**
 * author: Austin Andrews
 * id 2D68AA5F-ACA1-45AA-873B-AD077377E698
 * name arrow-down-bold-box-outline
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-bold-box-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomBoldBoxOutlineIcon = ArrowDownBoldBoxOutlineIcon;
export default ArrowBottomBoldBoxOutlineIcon